import React, { useEffect, useState } from 'react'
import { useAuth } from '../../context/AuthProvider';
import { BoxesIcon, CalendarIcon, ChevronLeft, HomeIcon, InfoIcon, LayoutGrid, LogOut, Menu, PlusCircleIcon, SettingsIcon, TruckIcon, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import boxlogo from "../../assets/logo/boxlogo.svg";
import boxlogoGreen from "../../assets/logo/boxlogo-green.svg";

import letterslogo from "../../assets/logo/letterslogo.svg"
import letterslogo_white from "../../assets/logo/letterslogo_white.svg"
import useNav from '../../hooks/useNav';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { Drawer, DrawerContent, DrawerTrigger } from '../ui/drawer';
import { getCustomSettings } from '../../config/custom-settings';
import { useBoundStore } from '../../zustand';
import { removeCookie } from '../../lib/cookie';

const Navigation = () => {
  const technician = useBoundStore((state) => state.technician)
  const { t } = useTranslation()
  const location = useLocation();
  const { nav } = useNav()
  const { auth, setAuth } = useAuth()
  const [open, setopen] = useState(false);
  const [active_page, setactive_page] = useState('startpagina');

  useEffect(() => {
    setactive_page(location.pathname.split("/")[1])
  }, [location])

  function handleLogout() {
    localStorage.clear()
    sessionStorage.clear()
    // Reset Zustand state
    useBoundStore.getState().reset()
    setAuth({ status: 'unauthenticated', data: null })
    removeCookie('mq-token')
  }

  const DashboardButton = () => (
    <>
      <Link onClick={() => { setopen(false) }} to="/startpagina">
        <li className={`${active_page === 'startpagina' ? 'after:content-[""] after:w-[2px] after:h-4 after:bg-white after:absolute after:-left-3 after:rounded-full' : 'opacity-60'} relative flex items-center gap-4 cursor-pointer p-2 hover:bg-emerald-700 rounded-md hover:opacity-100`}>
          <span><HomeIcon className='float-left w-5 text-white' strokeWidth={1.5} /></span>
          <span className={`${!open && 'md:hidden md:opacity-0'} text-white duration-200 text-base flex-1`}>{t('navigation.home')}</span>
        </li>
      </Link>
    </>
  )

  const CreateCallButton = () => (
    <>
      <Link onClick={() => { setopen(false) }} to="/oproep-aanmaken">
        <li className={`${active_page === 'oproep-aanmaken' ? 'after:content-[""] after:w-[2px] after:h-4 after:bg-white after:absolute after:-left-3 after:rounded-full' : 'opacity-60'} relative flex items-center gap-4 cursor-pointer p-2 hover:bg-emerald-700 rounded-md hover:opacity-100`}>
          <span><PlusCircleIcon className='float-left w-5 text-white' strokeWidth={1.5} /></span>
          <span className={`${!open && 'md:hidden md:opacity-0'} text-white duration-200 text-base flex-1`}>{t('navigation.create_call')}</span>
        </li>
      </Link>
    </>
  )

  const CalendarButton = () => (
    <>
      {getCustomSettings(auth.data?.databases[0].dbid).navigation?.calendar &&
        <Link onClick={() => { setopen(false) }} to="/kalender">
          <li className={`${active_page === 'kalender' ? 'after:content-[""] after:w-[2px] after:h-4 after:bg-white after:absolute after:-left-3 after:rounded-full' : 'opacity-60'} relative flex items-center gap-4 cursor-pointer p-2 hover:bg-emerald-700 rounded-md hover:opacity-100`}>
            <span><CalendarIcon className='float-left w-5 text-white' strokeWidth={1.5} /></span>
            <span className={`${!open && 'md:hidden md:opacity-0'} text-white duration-200 text-base flex-1`}>{t('navigation.calendar')}</span>
          </li>
        </Link>
      }
    </>
  )

  const ResetRideButton = () => (
    <>
      <button onClick={() => { toast.info('Rit gereset', { id: 'reset-ride', position: 'bottom-center' }) }} className='text-left'>
        <li className={`${active_page === 'rit-reset' ? 'after:content-[""] after:w-[2px] after:h-4 after:bg-white after:absolute after:-left-3 after:rounded-full' : 'opacity-60'} relative flex items-center gap-4 cursor-pointer p-2 hover:bg-emerald-700 rounded-md hover:opacity-100`}>
          <span><TruckIcon className='float-left w-5 text-white' strokeWidth={1.5} /></span>
          <span className={`${!open && 'md:hidden md:opacity-0'} text-white duration-200 text-base flex-1`}>{t('navigation.reset_rit')}</span>
        </li>
      </button>
    </>
  )

  const StockButton = () => (
    <Link onClick={() => { setopen(false) }} to="/stock">
      <li className={`${active_page === 'stock' ? 'after:content-[""] after:w-[2px] after:h-4 after:bg-white after:absolute after:-left-3 after:rounded-full' : 'opacity-60'} relative flex items-center gap-4 cursor-pointer p-2 hover:bg-emerald-700 rounded-md hover:opacity-100`}>
        <span><BoxesIcon className='float-left w-5 text-white' strokeWidth={1.5} /></span>
        <span className={`${!open && 'md:hidden md:opacity-0'} text-white duration-200 text-base flex-1`}>{t('navigation.stock')}</span>
      </li>
    </Link>
  )

  const SettingsButton = () => (
    <>
      <Link onClick={() => { setopen(false) }} to="/instellingen">
        <li className={`${active_page === 'instellingen' ? 'after:content-[""] after:w-[2px] after:h-4 after:bg-white after:absolute after:-left-3 after:rounded-full' : 'opacity-60'} relative flex items-center gap-4 cursor-pointer p-2 hover:bg-emerald-700 rounded-md hover:opacity-100`}>
          <span><SettingsIcon className='float-left w-5 text-white' strokeWidth={1.5} /></span>
          <span className={`${!open && 'md:hidden md:opacity-0'} text-white duration-200 text-base flex-1`}>{t('navigation.settings')}</span>
        </li>
      </Link>
    </>
  )

  const MoreInfoButton = () => (
    <>
      <Link onClick={() => { setopen(false) }} to="/meer-info">
        <li className={`${active_page === 'meer-info' ? 'after:content-[""] after:w-[2px] after:h-4 after:bg-white after:absolute after:-left-3 after:rounded-full' : 'opacity-60'} relative flex items-center gap-4 cursor-pointer p-2 hover:bg-emerald-700 rounded-md hover:opacity-100`}>
          <span><InfoIcon className='float-left w-5 text-white' strokeWidth={1.5} /></span>
          <span className={`${!open && 'md:hidden md:opacity-0'} text-white duration-200 text-base flex-1`}>{t('navigation.more_info')}</span>
        </li>
      </Link>
    </>
  )

  const NavButtons = () => (
    <>
      <DashboardButton />
      <CreateCallButton />
      <CalendarButton />
      <ResetRideButton />
      <StockButton />
      <SettingsButton />
      <MoreInfoButton />
    </>
  )

  return (
    <>
      <div className={`hidden md:flex flex-col sticky z-50 top-0 h-screen bg-emerald-800 p-5 pt-8 ${open ? "w-72" : "w-20"} duration-300 relative`}>
        <ChevronLeft onClick={() => { setopen(!open) }} className={`p-1 bg-white text-primary rounded-full absolute -right-3 top-9 drop-shadow-md cursor-pointer ${!open && 'rotate-180'}`} />

        <div className='flex flex-col justify-between h-full overflow-x-hidden overflow-y-auto'>
          <div>
            <div className='inline-flex items-center'>
              <img className='block float-left mx-2 cursor-pointer h-7' src={boxlogo} alt="Logo MountQ" />
              <img className={`${!open && 'scale-0'} duration-300 h-5 ml-2`} src={letterslogo_white} alt="White logo Loomis" />
            </div>

            <div className='w-full h-px my-6 bg-white/10'></div>

            <p className={`${!open && 'hidden'} text-neutral-400 font-semibold uppercase text-sm mb-4`}>Menu</p>

            <ul className='flex flex-col gap-2'>
              <NavButtons />
            </ul>
            <div className='w-full h-px my-4 bg-white/10'></div>
          </div>
        </div>
        <div>
          <div>
            <div className='w-full h-px my-2 bg-white/10'></div>

            <div className={`flex items-center ${open ? 'justify-between' : 'justify-center'} `}>
              <div>
                <p className={`${!open && 'hidden'} font-semibold text-white whitespace-nowrap`}>{auth.data?.firstname} {auth.data?.lastname}</p>
                <p className={`${!open && 'hidden'} text-sm text-white/70`}>Gekoppelde wagen: {technician?.m_sWAGENCODE}</p>
                <div className={`${open && 'hidden'} w-8 h-8 rounded-full bg-white flex items-center justify-center`}>
                  <p className='font-semibold'>{auth.data?.firstname.charAt(0)}</p>
                </div>
              </div>
            </div>
          </div>

          <div className='w-full h-px my-2 bg-white/10'></div>

          <button onClick={handleLogout} className='flex items-center w-full gap-4 p-2 rounded-md cursor-pointer hover:bg-emerald-700'>
            <span><LogOut className='float-left w-5 text-white' strokeWidth={1.5} /></span>
            <span className={`${!open && 'md:hidden md:opacity-0'} text-white duration-200 text-base`}>{t('navigation.logout')}</span>
          </button>
        </div>
      </div>

      {/* TOP */}
      <Drawer open={open} onOpenChange={(o) => { setopen(o) }} direction='right'>

        <div className='fixed top-0 left-0 z-40 w-screen h-16 bg-white border-b md:left-20 border-neutral-300'>
          <div className='flex items-center justify-between h-full gap-2 px-2 py-6'>

            <div className='flex items-center gap-2 md:pl-4'>
              <Link to="/startpagina"><img className='w-10 h-10 md:hidden' src={boxlogoGreen} alt="MountQ logo" /></Link>
              <p className='text-sm font-semibold'>{nav?.title}</p>
            </div>
            <DrawerTrigger asChild>
              <button onClick={() => { setopen(!open) }} className='flex items-center justify-center w-10 h-10 -ml-4'>
                <Menu className='w-6' />
              </button>
            </DrawerTrigger>
          </div>

          <DrawerContent className='max-w-[90dvw] w-full bg-emerald-800 inset-x-auto h-dvh rounded-t-none border-none rounded-l-xl p-4 !right-0'>
            <div>
              <div className={`flex flex-col justify-between h-full gap-2`}>
                <div>
                  <div className={`flex items-center justify-between`}>
                    <div className='flex items-center gap-2'>
                      <div className='flex items-center justify-center w-8 h-8 bg-white rounded-full'>
                        <p className='font-semibold'>{auth.data?.firstname.charAt(0)}</p>
                      </div>
                      <div className='text-white'>
                        <p className='font-semibold text-white whitespace-nowrap'>{auth.data?.firstname} {auth.data?.lastname}</p>
                        <p className='text-sm whitespace-nowrap text-white/70'>Gekoppelde wagen: {technician?.m_sWAGENCODE}</p>
                      </div>
                    </div>
                    <button onClick={() => { setopen(false) }} className='text-white'>
                      <X className='w-6 h-6' />
                    </button>
                  </div>

                  <div className='w-full h-px my-2 bg-white/10'></div>

                  <ul className='flex flex-col gap-2'>
                    <NavButtons />
                  </ul>
                </div>
                <button onClick={handleLogout} className='flex items-center w-full gap-4 p-2 rounded-md cursor-pointer hover:bg-emerald-700'>
                  <span><LogOut className='float-left w-5 text-white' strokeWidth={1.5} /></span>
                  <span className={`${!open && 'md:hidden md:opacity-0'} text-white duration-200 text-base`}>{t('navigation.logout')}</span>
                </button>
              </div>
            </div>
          </DrawerContent>
        </div>

      </Drawer>
    </>
  )
}

export default Navigation